import React from 'react'
import { Divider, Grid, Button } from '@mui/material';
import AddBins from './global-variable-tables/AddBins';
import AddEquipment from './global-variable-tables/AddEquipment';
import EquipmentMaintenance from './global-variable-tables/EquipmentMaintenance';
import DocumentUploads from './global-variable-tables/DocumentUploads';

const ProjectAssets = () => {
    const [selected, setSelected] = React.useState(0)

    const items = [
        {
            id: 0,
            title: 'Add Biochar Bins',
        },
        {
            id: 1,
            title: 'Add Biochar Equipment',
        },
        {
            id: 2,
            title: 'Equipment Maintenance',
        },
        {
            id: 3,
            title: 'Document Uploads',
        }
    ]

    return (
        <>
            <h1>Project Assets</h1>
            <Divider sx={{ my: 2 }} />
            <Grid container>
                <Grid item xs={2} sx={{ p: 2 }} display='flex' flexDirection={'column'} alignItems="flex-start">
                    {items.map((item, index) => {
                        return (
                            <Button
                                sx={{ mb: 3 }}
                                variant={selected === index ? 'contained' : 'outlined'}
                                key={index}
                                onClick={() => setSelected(index)}>{item.title}</Button>
                        )
                    })}
                </Grid>
                <Grid item xs={10} sx={{ p: 2 }}>
                    {selected === 0 ? <AddBins /> :
                        selected === 1 ? <AddEquipment /> :
                            selected === 2 ?
                                <EquipmentMaintenance /> :
                                <DocumentUploads />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default ProjectAssets